import React, { useState, useEffect } from "react";
import { Tab } from "semantic-ui-react";
import { LoadingSpinner } from "../../../components/Shared";
import { ListSites } from "../../../components/Admin/Sites";
import "./Sites.scss";
import { useAuth } from "../../../hooks";
import {
  isAdmin,
  hasPermission,
  isMaster,
} from "../../../utils/checkPermission";
import { ErrorAccessDenied } from "../Error";
import { Company, Permission } from "../../../api";
import { useLanguage } from "../../../contexts";

const permissionController = new Permission();
const companyController = new Company();

export function Sites() {
  const [reload, setReload] = useState(false);
  const [companySelected, setCompanySelected] = useState(null);

  const {
    accessToken,
    user: { role, company },
  } = useAuth();

  const [permissionsByRole, setPermissionsByRole] = useState([]);
  const [companiesFilter, setCompaniesFilter] = useState(null);

  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const onReload = () => setReload((prev) => !prev);

  useEffect(() => {
    (async () => {
      try {
        if (role) {
          const response = await permissionController.getPermissionsByRole(
            accessToken,
            role._id,
            true
          );
          setPermissionsByRole(response);
        }
      } catch (error) {
        console.error(error);
        setPermissionsByRole([]);
      }
    })();
  }, [accessToken, role]);

  useEffect(() => {
    (async () => {
      try {
        if (!company) {
          const response = await companyController.getCompanies(accessToken);
          setCompaniesFilter(response);
          if (response.length > 0) {
            setCompanySelected((prev) => prev || response[0]._id);
          }
        } else {
          setCompanySelected(company);
        }
      } catch (error) {
        console.error(error);
        setCompaniesFilter([]);
      }
    })();
  }, [accessToken, company]);

  const showCompanyDropdown = isMaster(role) && !company;

  const panes = [
    {
      menuItem: t("active_sites"),
      render: () => (
        <Tab.Pane attached={false}>
          {showCompanyDropdown && companiesFilter === null ? (
            <LoadingSpinner />
          ) : (
            <ListSites
              sitesActive={true}
              reload={reload}
              onReload={onReload}
              companySelected={companySelected}
              role={role}
              companies={showCompanyDropdown ? companiesFilter : null}
              onCompanyChange={setCompanySelected}
            />
          )}
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("inactive_sites"),
      render: () => (
        <Tab.Pane attached={false}>
          {showCompanyDropdown && companiesFilter === null ? (
            <LoadingSpinner />
          ) : (
            <ListSites
              sitesActive={false}
              reload={reload}
              onReload={onReload}
              companySelected={companySelected}
              role={role}
              companies={showCompanyDropdown ? companiesFilter : null}
              onCompanyChange={setCompanySelected}
            />
          )}
        </Tab.Pane>
      ),
    },
  ];

  if (
    isMaster(role) ||
    (isAdmin(role) && company) ||
    hasPermission(permissionsByRole, role._id, "sites", "view")
  ) {
    return (
      <div className="sites-page" style={{ padding: "0 0 1.5rem" }}>
        <div className="sites-page-header-wrapper">
          <div className="sites-page-header">
            <span className="sites-page-title">{t("sites")}</span>
          </div>
        </div>
        <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
      </div>
    );
  }

  return <ErrorAccessDenied />;
}
